import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";
import { generateTelegramLink } from "../data/telegramLinks";

export const SupportBubble = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-5 left-5 z-40 hidden md:block" data-testid="support-bubble">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 14, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 14, scale: 0.95 }}
            className="absolute bottom-16 left-0 w-[300px] rounded-2xl glass-strong p-5 border border-[#D7B56D]/30"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-3 right-3 text-[#D8DCE2]/60 hover:text-[#D7B56D]"
              aria-label={t("close")}
              data-testid="support-bubble-close"
            >
              <X size={14} />
            </button>
            <div className="font-mono text-[9px] uppercase tracking-[0.22em] text-[#76D9E8] mb-2">
              · Coach
            </div>
            <h4 className="font-display text-[15px] font-bold text-[#F5F1EA] mb-2 leading-snug pr-4">
              {t("supTitle")}
            </h4>
            <p className="text-[12px] text-[#D8DCE2]/75 leading-relaxed mb-4">{t("supText")}</p>
            <a
              href={generateTelegramLink("private-support")}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold !py-2 !px-4 text-[11px] w-full"
              data-testid="support-bubble-cta"
            >
              <MessageCircle size={12} /> {t("ctaAskTelegram")}
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full flex items-center justify-center bg-[#D7B56D] text-[#0a0b0f] shadow-2xl shadow-[#D7B56D]/30 hover:scale-110 transition-transform"
        data-testid="support-bubble-toggle"
        aria-label="Open support"
      >
        <MessageCircle size={20} />
      </button>
    </div>
  );
};
